import { GET_APPOINTMENT_LIST, GET_RESOURCE_LIST, GET_WAIT_LIST, GET_APPOINTMENT_DETAIL, RELOAD_CALENDAR, SELECT_RESOURCE, GET_FILTERED_LIST, GET_APPOINTMENT_SPECIFIC_DATE, CHECK_UPDATE, GET_LIST_SEARCH, } from "./posAppointmentTypes";

export default {
    [GET_APPOINTMENT_LIST](state, data) {
        state.appointmentList = data;
    },

    [GET_RESOURCE_LIST](state, data) {
        // let list = [];
        // if(data.items && data.items.length > 0) {
        //     for(let i = 0; i < data.items.length; i++) {
        //         let item = data.items[i];
        //         item.title = item.name;
        //         list.push(item);
        //     }
        // }
        let list = data.items ? data.items : [];
        state.resourceFilter = list;
        if (typeof state.resource === 'undefined' || !state.resource) {
            state.resourceList = list;
        } else {
            for (let i = 0; i < list.length; i++) {
                if (list[i].id == state.resource.id) {
                    state.resourceList = [list[i]];
                    break;
                }
            }
        }
    },

    [GET_WAIT_LIST](state, data) {
        let list = data.items ? data.items : [];
        let walkinWaitList = [];
        let appointmentWaitList = [];

        if(list.length > 0) {
            for(let i = 0; i < list.length; i++) {
                if(list[i].appointment) {
                    appointmentWaitList.push(list[i]);
                } else {
                    walkinWaitList.push(list[i]);
                }
            }
        }

        state.waitList = list;
        state.walkinWaitList = walkinWaitList;
        state.appointmentWaitList = appointmentWaitList;
    },

    [GET_APPOINTMENT_DETAIL](state, data) {
        state.appointmentDetail = data;
    },

    [RELOAD_CALENDAR](state, data) {
        state.calendarView = data;
        state.posCalendarView = data;
    },

    [SELECT_RESOURCE](state, data) {
        state.resource = data;
    },

    [GET_FILTERED_LIST](state) {
        let list = [];
        if (state.resource == null) {
            if (state.calendarView.type == "1d" || state.calendarView.type === undefined) {
                list = state.appointmentList;
            }
            else {
                for (let i = 0; i < state.appointmentList.length; i++) {
                    if (state.appointmentList[i].rendering != "background" || state.appointmentList[i].resourceId == null) {
                        list.push(state.appointmentList[i]);
                    }
                }
            }
        } else {
            for (let i = 0; i < state.appointmentList.length; i++) {
                if (state.appointmentList[i].resourceId == state.resource.id || state.appointmentList[i].resourceId == null) {
                    list.push(state.appointmentList[i]);
                }
            }
        }
        state.filteredList = list;
    },

    [GET_APPOINTMENT_SPECIFIC_DATE](state, data) {
        state.specificDate = data;
    },

    [CHECK_UPDATE](state, data) {
        state.currentId = data;
    },

    [GET_LIST_SEARCH](state, data) {
        state.appointmentSearchList = data;
    },
}
